import { userConstants } from "../../constant";

const initialState = {
  on_waitlist: false,
  waitlist_count: 0,
  total_demand: 0,
  quantity_needed: 0,
  entries: [],
  exclusive_window: null,
  // User's full waitlist
  userWaitlist: [],
  userWaitlistLoading: false,
  // Seller demand view
  sellerDemand: [],
  sellerDemandLoading: false,
  // Exclusive window check
  exclusiveWindowInfo: null,
};

export function waitlist(state = initialState, action) {
  switch (action.type) {
    case userConstants.JOIN_WAITLIST:
      return {
        ...state,
        on_waitlist: true,
        waitlist_count: action.payload.waitlist_count || state.waitlist_count + 1,
        total_demand: action.payload.total_demand || state.total_demand,
        quantity_needed: action.payload.quantity_needed || state.quantity_needed,
      };
    case userConstants.LEAVE_WAITLIST:
      return {
        ...state,
        on_waitlist: false,
        waitlist_count: Math.max(0, state.waitlist_count - 1),
        quantity_needed: 0,
      };
    case userConstants.GET_WAITLIST_STATUS:
      return {
        ...state,
        on_waitlist: action.payload.on_waitlist || false,
        waitlist_count: action.payload.waitlist_count || 0,
        total_demand: action.payload.total_demand || 0,
        quantity_needed: action.payload.quantity_needed || 0,
        entries: action.payload.entries || [],
        exclusive_window: action.payload.exclusive_window || null,
      };
    case userConstants.GET_USER_WAITLIST:
      return {
        ...state,
        userWaitlist: action.payload || [],
        userWaitlistLoading: false,
      };
    case "GET_USER_WAITLIST_LOADING":
      return {
        ...state,
        userWaitlistLoading: true,
      };
    case userConstants.GET_SELLER_WAITLIST_DEMAND:
      return {
        ...state,
        sellerDemand: action.payload || [],
        sellerDemandLoading: false,
      };
    case "GET_SELLER_WAITLIST_DEMAND_LOADING":
      return {
        ...state,
        sellerDemandLoading: true,
      };
    case userConstants.WAITLIST_DEPOSIT:
      return {
        ...state,
        userWaitlist: state.userWaitlist.map((item) =>
          item.id === action.payload.entryId
            ? { ...item, deposit_paid: true, deposit_amount: action.payload.deposit_amount }
            : item
        ),
      };
    case userConstants.GET_EXCLUSIVE_WINDOW:
      return {
        ...state,
        exclusiveWindowInfo: action.payload,
      };
    default:
      return state;
  }
}
